import ManageData from './ManageData'

export default ManageData
